import { icon } from '@fortawesome/fontawesome-svg-core';
import { HistoryEdu, QuestionAnswerOutlined, ArchiveOutlined, LocalPharmacyOutlined, LocalHospitalOutlined, EmergencyOutlined } from '@mui/icons-material';
import { Elderly } from '@mui/icons-material';
import Stethoscope from "Images/stethoscope.svg"
import { Image } from 'react-bootstrap';
import { PATHS } from 'Utils/PagePaths';
import { ICONS } from 'Utils/icons';

/**Top Navigation const */
export const TOP_NAV_ITEMS = [
  {
    type: "listItem",
    title: "Become a PSO",
    link: PATHS.public['Become a PSO'],
    hidden: (e) => {
      if (e == true) {
        return true;
      }
      else {
        return false;
      }
    }
  },
  {
    type: "subMenu",
    title: "Use Common Formats",
    align: "start",
    id: "ahrqCommonFormatsMenu",
    items: {
      col1: [
        {
          link: PATHS.public['Current Common Formats'],
          title: "Current Common Formats",
          desc: "Learn more on the AHRQ Common Formats",
          icon: () => <HistoryEdu ></HistoryEdu>,
          subMenuKey: "currentCF"
          // [
          //     { link: PATHS.public['Surveillance - Hospital'], title: "Surveillance - Hospital", desc: "Version 1.0", icon: () => <EmergencyOutlined></EmergencyOutlined> },
          //     { link: PATHS.public['Diagnostic Safety'], title: "Diagnostic Safety", desc: "Version 1.0", icon: () => <Image alt="Stethoscope" src={Stethoscope}></Image> },
          //     { link: PATHS.public['Nursing Home'], title: "Nursing Home", desc: "Version 1.0", icon: () => <Elderly></Elderly> },
          //     { link: PATHS.public['Hospital Version 2.0'], title: "Hospital", desc: "Version 2.0", icon: () => <LocalHospitalOutlined ></LocalHospitalOutlined> },
          //     { link: PATHS.public['Community Pharmacy'], title: "Community Pharmacy", desc: "Version 1.0", icon: () => <LocalPharmacyOutlined ></LocalPharmacyOutlined> },
          //     // example of using download svg if MUI Icon could not meet requirements
          //     { link: PATHS.public['Hospital Version 1.2'], title: "Hospital", desc: "Version 1.2", icon: () => <LocalHospitalOutlined ></LocalHospitalOutlined> }
          // ]
        },
        {
          link: PATHS.public['Common Formats Repository'], title: "Common Formats Repository", desc: "Explore Common Formats data elements", icon: () => <svg xmlns="http://www.w3.org/2000/svg" width="26" height="28" viewBox="0 0 26 28" fill="none">
            <path d="M13 24.2025C10.2736 24.2025 7.96701 23.7559 6.08021 22.8627C4.1934 21.9695 3.25 20.8795 3.25 19.5925V8.06752C3.25 6.79977 4.20243 5.7145 6.10729 4.81171C8.01215 3.90892 10.3097 3.45752 13 3.45752C15.6903 3.45752 17.9878 3.90892 19.8927 4.81171C21.7976 5.7145 22.75 6.79977 22.75 8.06752V19.5925C22.75 20.8795 21.8066 21.9695 19.9198 22.8627C18.033 23.7559 15.7264 24.2025 13 24.2025ZM13 10.4013C14.6069 10.4013 16.2229 10.1564 17.8479 9.66661C19.4729 9.1768 20.3847 8.65337 20.5833 8.09633C20.3847 7.53929 19.4774 7.01106 17.8615 6.51164C16.2455 6.01223 14.625 5.76252 13 5.76252C11.3569 5.76252 9.74549 6.00743 8.16563 6.49724C6.58576 6.98705 5.66944 7.52008 5.41667 8.09633C5.66944 8.67258 6.58576 9.20081 8.16563 9.68102C9.74549 10.1612 11.3569 10.4013 13 10.4013ZM13 16.135C13.7583 16.135 14.4896 16.0966 15.1938 16.0198C15.8979 15.9429 16.5705 15.8325 17.2115 15.6884C17.8524 15.5444 18.4573 15.3667 19.026 15.1554C19.5948 14.9441 20.1139 14.704 20.5833 14.4351V10.9776C20.1139 11.2465 19.5948 11.4866 19.026 11.6979C18.4573 11.9092 17.8524 12.0869 17.2115 12.2309C16.5705 12.375 15.8979 12.4854 15.1938 12.5623C14.4896 12.6391 13.7583 12.6775 13 12.6775C12.2417 12.6775 11.5014 12.6391 10.7792 12.5623C10.0569 12.4854 9.37535 12.375 8.73438 12.2309C8.0934 12.0869 7.49306 11.9092 6.93333 11.6979C6.37361 11.4866 5.86806 11.2465 5.41667 10.9776V14.4351C5.86806 14.704 6.37361 14.9441 6.93333 15.1554C7.49306 15.3667 8.0934 15.5444 8.73438 15.6884C9.37535 15.8325 10.0569 15.9429 10.7792 16.0198C11.5014 16.0966 12.2417 16.135 13 16.135ZM13 21.8975C13.8306 21.8975 14.6747 21.8303 15.5323 21.6958C16.3899 21.5614 17.1799 21.3837 17.9021 21.1628C18.6243 20.9419 19.2292 20.6922 19.7167 20.4137C20.2042 20.1352 20.4931 19.8518 20.5833 19.5637V16.7401C20.1139 17.009 19.5948 17.2491 19.026 17.4604C18.4573 17.6717 17.8524 17.8494 17.2115 17.9934C16.5705 18.1375 15.8979 18.2479 15.1938 18.3248C14.4896 18.4016 13.7583 18.44 13 18.44C12.2417 18.44 11.5014 18.4016 10.7792 18.3248C10.0569 18.2479 9.37535 18.1375 8.73438 17.9934C8.0934 17.8494 7.49306 17.6717 6.93333 17.4604C6.37361 17.2491 5.86806 17.009 5.41667 16.7401V19.5925C5.50694 19.8806 5.79132 20.1592 6.26979 20.4281C6.74826 20.697 7.34861 20.9419 8.07083 21.1628C8.79306 21.3837 9.5875 21.5614 10.4542 21.6958C11.3208 21.8303 12.1694 21.8975 13 21.8975Z" fill="#0B4870" />
          </svg>
        },
        { link: PATHS.public['Provide Feedback'], title: "Provide Feedback", desc: "Provide feedback on Common Formats Event", icon: () => <QuestionAnswerOutlined ></QuestionAnswerOutlined> },
        { link: PATHS.public['Retired Common Formats'], title: "Retired Common Formats", desc: "Retired AHRQ Common Formats", icon: () => <ArchiveOutlined ></ArchiveOutlined> }
      ],
      // col2: [
      //     { link: PATHS.public['Surveillance - Hospital'], title: "Surveillance - Hospital", desc: "Version 1.0", icon: () => <EmergencyOutlined></EmergencyOutlined>},
      //     { link: PATHS.public['Diagnostic Safety'], title: "Diagnostic Safety", desc: "Version 1.0", icon: () => <Image alt="Stethoscope" src={Stethoscope}></Image> },
      //     { link: PATHS.public['Nursing Home'], title: "Nursing Home", desc: "Version 1.0", icon: () => <Elderly></Elderly> },
      //     { link: PATHS.public['Hospital Version 2.0'], title: "Hospital", desc: "Version 2.0", icon: () => <LocalHospitalOutlined ></LocalHospitalOutlined> },
      //     { link: PATHS.public['Community Pharmacy'], title: "Community Pharmacy", desc: "Version 1.0", icon: () => <LocalPharmacyOutlined ></LocalPharmacyOutlined> },
      //     // example of using download svg if MUI Icon could not meet requirements
      //     { link: PATHS.public['Hospital Version 1.2'], title: "Hospital", desc: "Version 1.2", icon: () => <LocalHospitalOutlined ></LocalHospitalOutlined> }
      // ]
      subMenus: {
        currentCF: {
          label: "Individual Current Common Formats Pages",
          links: [
            { link: PATHS.public['Surveillance - Hospital'], title: "Surveillance - Hospital", desc: "Version 1.0", icon: () => <EmergencyOutlined></EmergencyOutlined> },
            { link: PATHS.public['Diagnostic Safety'], title: "Diagnostic Safety", desc: "Version 1.0", icon: () => <Image alt="Stethoscope" src={Stethoscope}></Image> },
            { link: PATHS.public['Nursing Home'], title: "Nursing Home", desc: "Version 1.0", icon: () => <Elderly></Elderly> },
            { link: PATHS.public['Hospital Version 2.0'], title: "Hospital", desc: "Version 2.0", icon: () => <LocalHospitalOutlined ></LocalHospitalOutlined> },
            { link: PATHS.public['Community Pharmacy'], title: "Community Pharmacy", desc: "Version 1.0", icon: () => <LocalPharmacyOutlined ></LocalPharmacyOutlined> },
            // example of using download svg if MUI Icon could not meet requirements
            { link: PATHS.public['Hospital Version 1.2'], title: "Hospital", desc: "Version 1.2", icon: () => <LocalHospitalOutlined ></LocalHospitalOutlined> }
          ]
        }
      }
    },


  },
  {
    type: "listItem",
    title: "Submit Data",
    link: PATHS.public['Submit Data']
  },
  {
    type: "listItem",
    title: "Learn from the Data",
    link: PATHS.public['Learn from the Data']
  },
  {
    type: "listItem",
    title: "Data Security",
    link: PATHS.public['Data Security']
  },
  {
    type: "subMenu",
    title: "Resources",
    align: { xxl: 'start', lg: 'end' },
    id: "resourcesMenu",
    items: {
      col1: [
        { link: PATHS.public['PSOPPC Articles'], title: "PSOPPC Articles", desc: "Our collection of articles including insights, new features, and more", icon: ICONS.feedOutlined },
        {
          link: PATHS.public['User Account Types'], title: "User Account Types", desc: "Review the accounts we offer at PSOPPC", icon: ICONS.personOutlined
        }
      ],
      col2: []
    }
  },
];

export const TOP_NAV_ITEMS_AS_LEFT_NAV = [
  {
    type: "listItem",
    menuName1: "Become a PSO",
    menuLink: PATHS.public['Become a PSO'],
  },
  {
    type: "subMenu",
    title: "Use Common Formats",
    subList: [
      {
        menuLink: PATHS.public['Current Common Formats'],
        menuName1: "Use Common Formats",
        menuName2: "Current Common Formats"
      },
      {
        menuLink: PATHS.public['Common Formats Repository'],
        menuName1: "Use Common Formats",
        menuName2: "Common Formats Repository"
      },

      /* comment out feedback for UAT: TODO:!!! revert for commenting tool development*/
      {
        menuLink: PATHS.public['Provide Feedback'],
        menuName1: "Use Common Formats",
        menuName2: "Provide Feedback"
      },

      {
        menuLink: PATHS.public['Retired Common Formats'],
        menuName1: "Use Common Formats",
        menuName2: "Retired Common Formats"
      },
      {
        menuLink: PATHS.public['Surveillance - Hospital'],
        menuName1: "Use Common Formats",
        menuName2: "Surveillance - Hospital Version 1.0"
      },
      {
        menuLink: PATHS.public['Diagnostic Safety'],
        menuName1: "Use Common Formats",
        menuName2: "Diagnostic Safety"
      },
      {
        menuLink: PATHS.public['Nursing Home'],
        menuName1: "Use Common Formats",
        menuName2: "Nursing Home Version 1.0"
      },
      {
        menuLink: PATHS.public['Hospital Version 2.0'],
        menuName1: "Use Common Formats",
        menuName2: "Hospital Version 2.0"
      },
      {
        menuLink: PATHS.public['Community Pharmacy'],
        menuName1: "Use Common Formats",
        menuName2: "Community Pharmacy"
      },
      {
        menuLink: PATHS.public['Hospital Version 1.2'],
        menuName1: "Use Common Formats",
        menuName2: "Hospital Version 1.2"
      }
    ]
  },
  {
    type: "listItem",
    menuName1: "Submit Data",
    menuLink: PATHS.public['Submit Data'],
  },
  {
    type: "listItem",
    menuName1: "Learn from the Data",
    menuLink: PATHS.public['Learn from the Data'],
  },
  {
    type: "listItem",
    menuName1: "Data Security",
    menuLink: PATHS.public['Data Security']
  },
  {
    type: "subMenu",
    title: "Resources",
    subList: [
      {
        menuLink: PATHS.public['PSOPPC Articles'],
        menuName1: "Resources",
        menuName2: "PSOPPC Articles"
      },
      {
        menuLink: PATHS.public['User Account Types'],
        menuName1: "Resources",
        menuName2: "User Account Types"
      },
    ]
  },
];

export const USER_PROFILE_ITEMS_AS_LEFT_NAV = [
  {
    type: "subMenu",
    title: "Account Settings",
    subList: [
      {
        menuLink: PATHS.private["editUserProfile"],
        menuName1: "My Profile",
        menuName2: "My Profile"
      },
      {
        menuLink: PATHS.private["resetUserPassword"],
        menuName1: "My Profile",
        menuName2: "Reset Password"
      },
      {
        menuLink: PATHS.private["setupMfa"],
        menuName1: "My Profile",
        menuName2: "Two-Factor Authentication"
      },
      /**TODO:!!! 09/24/2026 to revert after pro release */
      // {
      //   menuLink: PATHS.private["editUserProfilePicture"],
      //   menuName1: "My Profile",
      //   menuName2: "Profile Picture"
      // },
    ]
  }
  /* comment out for MVP release
  {
    type: "listItem",
    menuName1: "Notifications",
    menuLink: "/publicpages/notifications"
  } */
];

export const HELP_ABOUT_AS_LEFT_NAV = [
  {
    type: "listItem",
    menuName1: "News & Updates",
    menuLink: PATHS.public["News & Updates"]
  },
  {
    type: "listItem",
    menuName1: "Get Help",
    menuLink: PATHS.public["Get Help"]
  },
  {
    type: "listItem",
    menuName1: "About PSOPPC",
    menuLink: PATHS.public["About PSOPPC"]
  }
];